import React from 'react';
import * as Styled from './styles';

interface IProps {
  children: React.ReactNode
}

export const VisibilityHidden: React.FC<IProps> = ({ children }) => (
  <Styled.VisibilityHiddenStyled>
    {children}
  </Styled.VisibilityHiddenStyled>
);
